import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Mail, Lock, ArrowRight, ShoppingBag } from "lucide-react";
import userAPI from "../../api/UserApi";
import { handleApiValidationError } from "../../utils/apiErrorHandler";

export default function LoginPage() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({ email: "", password: "" });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const validate = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email) {
      newErrors.email = "Email address is required";
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = "Please enter a valid email";
    }
    if (!formData.password) {
      newErrors.password = "Password is required";
    } else if (formData.password.length < 6) {
      newErrors.password = "Password must be at least 6 characters";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);
    try {
      const res = await userAPI.login(formData);
      if (res.code === 200) {
        localStorage.setItem("token", JSON.stringify({
          email: res.data.email,
          username: res.data.username,
        }));
        localStorage.setItem("accessToken", res.data.accessToken);
        navigate("/users/dashboard");
      }
    } catch (err) {
      handleApiValidationError(err, setErrors);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page-wrapper">
      {/* Left panel — decorative */}
      <div className="auth-panel auth-panel--left">
        <div className="auth-panel__overlay" />
        <div className="auth-panel__content">
          <div className="auth-brand">
            <ShoppingBag size={32} color="#D4AF37" />
            <span>Premium Store</span>
          </div>
          <h2 className="auth-panel__headline">
            Welcome back to a world of elegance.
          </h2>
          <p className="auth-panel__sub">
            Sign in to access your orders, wishlist, and exclusive member offers.
          </p>
          <div className="auth-panel__dots">
            <span className="dot dot--active" />
            <span className="dot" />
            <span className="dot" />
          </div>
        </div>
      </div>

      {/* Right panel — form */}
      <div className="auth-panel auth-panel--right">
        <div className="auth-form-box">
          <p className="auth-form-eyebrow">Member Access</p>
          <h1 className="auth-form-title">Sign In</h1>
          <p className="auth-form-subtitle">
            Don't have an account?{" "}
            <Link to="/users/register" className="auth-link">
              Create one
            </Link>
          </p>

          <form onSubmit={handleSubmit} className="auth-form" noValidate>
            {/* Email */}
            <div className="auth-field">
              <label className="auth-label" htmlFor="email">
                Email Address
              </label>
              <div className={`auth-input-wrap ${errors.email ? "has-error" : ""}`}>
                <Mail size={17} className="auth-input-icon" />
                <input
                  id="email"
                  type="email"
                  name="email"
                  placeholder="you@example.com"
                  value={formData.email}
                  onChange={handleChange}
                  autoComplete="email"
                />
              </div>
              {errors.email && (
                <span className="auth-error">{errors.email}</span>
              )}
            </div>

            {/* Password */}
            {/* Password */}
<div className="auth-field">
  <label className="auth-label" htmlFor="password">
    Password
  </label>
  <div className={`auth-input-wrap ${errors.password ? "has-error" : ""}`}>
    <Lock size={17} className="auth-input-icon" />
    <input
      id="password"
      type="password"
      name="password"
      placeholder="Min. 6 characters"
      value={formData.password}
      onChange={handleChange}
      autoComplete="current-password"
    />
  </div>
  {errors.password && (
    <span className="auth-error">{errors.password}</span>
  )}
  <div className="auth-forgot-row">
    <Link to="/users/forgot-password" className="auth-link auth-forgot-link">
      Forgot Password?
    </Link>
  </div>
</div>

            <button
              type="submit"
              className="auth-submit-btn"
              disabled={loading}
            >
              {loading ? (
                <span className="auth-spinner" />
              ) : (
                <>
                  Sign In <ArrowRight size={17} className="ms-2" />
                </>
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}